import React, { useState } from 'react';
import apiClient from '@/utils/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { WorkflowDialogContent } from '@/components/ui/workflow-dialog';
import { Label } from '@/components/ui/label';

export const COUNSELLING_MODES = [
  ['phone_call', 'Phone call'], ['google_meet', 'Google Meet'], ['whatsapp_call', 'WhatsApp call'],
];
export const modeLabel = mode => COUNSELLING_MODES.find(([value]) => value === mode)?.[1] || 'Mode not set';
export const ModeSelect = ({ value, onChange, testId }) => <div className="space-y-1">
  <Label htmlFor={testId}>Counselling mode *</Label>
  <select id={testId} data-testid={testId} required value={value} onChange={e => onChange(e.target.value)} className="w-full min-h-[44px] bg-white border rounded-md px-3 text-sm">
    <option value="">Select mode…</option>{COUNSELLING_MODES.map(([key, label]) => <option key={key} value={key}>{label}</option>)}
  </select>
</div>;

export const SessionDetailsDialog = ({ appointment, onClose, onSaved }) => {
  const [mode, setMode] = useState(appointment.counselling_mode || '');
  const [link, setLink] = useState(appointment.video_link || ''), [saving, setSaving] = useState(false);
  const save = async e => {
    e.preventDefault(); if (saving || !mode) return;
    setSaving(true);
    try {
      await apiClient.patch(`/workflow/appointments/${appointment.id}/session-details`, { counselling_mode: mode, video_link: mode === 'google_meet' ? link || null : null });
      toast.success(mode === 'google_meet' && link ? 'Meeting link saved for WhatsApp sharing' : 'Session details saved');
      onSaved(); onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not save session details'); }
    finally { setSaving(false); }
  };
  return <Dialog open onOpenChange={() => { if (!saving) onClose(); }}><WorkflowDialogContent aria-describedby={undefined} data-testid="session-details-dialog">
    <DialogHeader className="workflow-dialog-header"><DialogTitle>Session details</DialogTitle></DialogHeader>
    <form onSubmit={save} className="workflow-dialog-form" data-testid="session-details-form">
      <div className="workflow-dialog-body space-y-3" data-testid="session-details-body">
      <ModeSelect value={mode} onChange={setMode} testId="session-details-mode" />
      {mode === 'google_meet' && <div className="space-y-2"><Label htmlFor="session-meet-link">Google Meet link</Label><Input id="session-meet-link" data-testid="session-meet-link" type="url" placeholder="https://meet.google.com/…" value={link} onChange={e => setLink(e.target.value)} /><p className="text-xs text-slate-500" data-testid="session-link-queue-note">WhatsApp sharing requires an approved WATI template.</p></div>}
      </div>
      <div className="workflow-dialog-footer" data-testid="session-details-footer"><Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="session-details-cancel">Cancel</Button><Button disabled={saving || !mode} data-testid="session-details-save">{saving ? 'Saving…' : 'Save'}</Button></div>
    </form>
  </WorkflowDialogContent></Dialog>;
};